// extracted by mini-css-extract-plugin
module.exports =  {"container":"_7a3fb80146--container--SwdHE","video":"_7a3fb80146--video--mwwFz","poster":"_7a3fb80146--poster--aD964","poster--hidden":"_7a3fb80146--poster--hidden--t4a23"};